"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Avatar/MessageAvatar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _Message = require('shared/components/Message');
var _sender = require('shared/services/sender');

var _BaseAvatar = require('./BaseAvatar'); var _BaseAvatar2 = _interopRequireDefault(_BaseAvatar);
var _PatientAvatar = require('./PatientAvatar'); var _PatientAvatar2 = _interopRequireDefault(_PatientAvatar);
var _UserAvatar = require('./UserAvatar'); var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

 const API_KEY_AVATAR_ALT_TEXT = 'API integration'; exports.API_KEY_AVATAR_ALT_TEXT = API_KEY_AVATAR_ALT_TEXT






const MessageAvatar = ({
  senderKey,
  senderType,
  profilePicture,
  ...props
}) => {
  // An API key has no photo or initials: a neutral integration avatar.
  if (_sender.isApiKeySender.call(void 0, senderType)) {
    return (
      _react2.default.createElement(_BaseAvatar2.default, {
        ...props,
        backgroundColorKey: senderKey,
        icon: "/assets/icons/avatar/icon-org.svg",
        iconAltText: exports.API_KEY_AVATAR_ALT_TEXT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      )
    )
  }

  if (profilePicture !== undefined) {
    const isPatient = _sender.getSenderSide.call(void 0, senderType) === 'patient'
    return (
      _react2.default.createElement(_BaseAvatar2.default, {
        ...props,
        backgroundColorKey: senderKey,
        profilePicture: profilePicture || undefined,
        isPatient: isPatient,
        icon: isPatient
          ? '/assets/icons/avatar/icon-person.svg'
          : '/assets/icons/avatar/icon-doctor.svg', __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
    )
  }

  switch (senderType) {
    case _Message.SenderTypes.PATIENT:
      return _react2.default.createElement(_PatientAvatar2.default, { patientKey: senderKey , ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
    case _Message.SenderTypes.USER:
      return _react2.default.createElement(_UserAvatar2.default, { userKey: senderKey , ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} )
    // An unknown SenderType (a newer backend) gets the plain avatar.
    default:
      return _react2.default.createElement(_BaseAvatar2.default, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
  }
}

exports. default = MessageAvatar
